import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Injector, ViewChild } from '@angular/core';
import { WidgetBase } from '../../widget-content/base/widget-base';
import { WidgetContentForumListingComponent } from '../../widget-content/forum-listing/forum-listing.component';

@Component({
    selector: 'fi-widget-forum-listing',
    templateUrl: './forum-listing.component.html',
    styleUrls: ['./forum-listing.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-widget-forum-listing' },
    standalone: false,
})
export class WidgetForumListingComponent extends WidgetBase {
    constructor(injector: Injector) {
        super(injector);
    }

    @ViewChild(WidgetContentForumListingComponent, { static: false })
    forumListingContent: WidgetContentForumListingComponent;

    get isEmpty$() {
        return this.forumListingContent.isEmpty$;
    }
}
